import { PartialDocumentoDate } from "./documentDate";
import { PartialDoctorSignature } from "./doctorSignature";
import { PartialResponsibleSignature } from "./responsibleSignature";

export const partials = {
  documentoDate: PartialDocumentoDate,
  doctorSignature: PartialDoctorSignature,
  responsibleSignature: PartialResponsibleSignature,
};
